export default "skymp5-front/6608f76002bdb844357fe998237ddef5.png";